module.exports = __webpack_public_path__ + "img/JobInfo.fa504c10.svg";